export default "__VITE_ASSET__BjlHMiwY__"